import { render, staticRenderFns } from "./AccessoryForm.vue?vue&type=template&id=46843b03&scoped=true"
import script from "./AccessoryForm.vue?vue&type=script&lang=js"
export * from "./AccessoryForm.vue?vue&type=script&lang=js"
import style0 from "./AccessoryForm.vue?vue&type=style&index=0&id=46843b03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46843b03",
  null
  
)

export default component.exports